import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const InputDate = (props) => {
  const {
    label,
    variant,
    size,
    name,
    value,
    onChange,
    error,
    minDate,
    maxDate,
    openTo = "day",
    fullWidth = true,
    required = false,
    views = ["day", "month", "year"],
    ...other
  } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        name={name}
        value={(value && dayjs(value)) || null}
        onChange={onChange}
        views={views}
        openTo={openTo}
        minDate={(minDate && dayjs(minDate)) || null}
        maxDate={(maxDate && dayjs(maxDate)) || null}
        slotProps={{
          textField: {
            variant: variant,
            size: size || "small",
            fullWidth: fullWidth,
            ...other,
            ...(error && { error: true, helperText: error }),
            required: required,
          },

          desktopPaper: {
            style: {
              backgroundColor: "var(--white-color)",
              boxShadow: "none",
              border: "1px solid var(--primaryMD-color)",
            },
          },
          mobilePaper: {
            style: {
              backgroundColor: "var(--white-color)",
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default InputDate;
